import React from "react";
import { Loader } from "../../../loader/index.js";
import { useInputContext } from "../Input/Input.context.js";
import filteredOptionsUtil from "./filtered-options-util.js";
const LoadingMessage = () => {
    const { inputProps: { id }, } = useInputContext();
    return (React.createElement("div", { className: "navds-combobox__list-item--loading", id: filteredOptionsUtil.getIsLoadingId(id) },
        React.createElement(Loader, { title: "S\u00F8ker..." })));
};
export default LoadingMessage;
//# sourceMappingURL=LoadingMessage.js.map